import { render, staticRenderFns } from "./emoji-picker-dialog.vue?vue&type=template&id=c91c6890&scoped=true"
import script from "./emoji-picker-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./emoji-picker-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./style/index.scss?vue&type=style&index=0&id=c91c6890&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91c6890",
  null
  
)

export default component.exports